import jwt_decode from 'jwt-decode';

export function resolverUnidadeCronograma(unidade, value) {
  if (unidade === 1)
    //dia
    return parseInt(value);
  else if (unidade === 2)
    //mês
    return transformarMesesEmDias(parseInt(value));
  else if (unidade === 3)
    //ano
    return parseInt(value) * 365;
}

export function resolverUnidadeCronogramaTest(unidade, value) {
  if (unidade === 1)
    //dia
    return parseInt(value);
  else if (unidade === 2) {
    //mês
    const quantidadeMeses = parseInt(value);

    if (quantidadeMeses >= 12) {
      const anos = parseInt(quantidadeMeses / 12);

      return quantidadeMeses * 30 + anos * 5;
    } else return quantidadeMeses * 30;
  } else if (unidade === 3)
    //ano
    return parseInt(value) * 365;
}

export function transformarMesesEmDias(meses) {
  if (meses >= 12) {
    const anos = parseInt(meses / 12);

    return meses * 30 + anos * 5;
  } else return meses * 30;
}

export function isTokenValid(token) {
  try {
    if (token) {
      const decodedToken = jwt_decode(token, { complete: true });

      if (!decodedToken || !decodedToken?.exp) {
        return false; // Token inválido, falta de informações ou campo exp ausente
      }

      const currentTimeInSeconds = Math.floor(Date.now() / 1000);
      const exp = decodedToken?.payload?.exp || decodedToken?.exp
      return exp > currentTimeInSeconds;
    } else return false;
  } catch (error) {
    console.error('Erro ao decodificar o token JWT:', error);
    return false;
  }
}
